import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ManageHeaderService } from '../Services/ManageHeaderService';

@Component({
  selector: 'ManagementHeader',
  templateUrl: './ManagementHeader.html',
  styleUrls: ['../../Content/css/bootstrap.css', '../../Content/css/custom.css', '../../Content/css/master.css', '../../Content/css/innflow-top-menu.css',
    '../../Content/css/innflow-main.css', '../../Content/css/jquery.dropdownReplacement.css',
    '../../Content/css/jquery.dropdownReplacementhotel.css'],
  providers: [ManageHeaderService]
})
export class ManagementHeader implements OnInit {
  ModuleValue: any = {};
  NavModule: any = {};
  NavNamepushvalue: any = [];
  NavNamepushOrganization: any = [];
  NavNamepushAdministrationvalue: any = [];
  RoleID: string;
  azureTolenKey: any = [];
  MasterImage: any = "../../assets/images/Master.png"
  Whiteline: any = "../../assets/images/white-line.png"
  constructor(private _route: Router, private _headerService: ManageHeaderService) {

  }

  ngOnInit() {
    this.GetModuleName();
    this.GetAzureTokenKey();
    //this.ModuleValue = 'Management';
    //this.Getmodulevalue(this.ModuleValue);
  }

  GetModuleName() {
  //  
    this.RoleID = sessionStorage.getItem('RoleID');
    this._headerService.GetAllModules(this.RoleID).subscribe(res => {
      var data = res;
      this.NavModule = data;
      for (let i = 0; i <= this.NavModule.length-1; i++) {
        if (this.NavModule[i].Role == "1" || this.NavModule[i].Role == "2" || this.NavModule[i].Role == "3") {
          if (this.NavModule[i].Menuitem == "Administration") {
            //
            this.NavNamepushAdministrationvalue.push(this.NavModule[i].SubMenuItem);
          }
          else {
            this.NavNamepushvalue.push(this.NavModule[i].Menuitem);
          }
        }
        else {
          this.NavNamepushvalue.push(this.NavModule[i].Menuitem);
        }

      }
    })
  }

  GetAzureTokenKey() {
    //
    this._headerService.GetAzureKey().subscribe(res => {
      var Azuredata = res;
      if (Azuredata[0]) {
        this.azureTolenKey = Azuredata[0].Value;
        localStorage.setItem("azureTolenKey", this.azureTolenKey);
      }

    });
  }

  GetNavValue(Val: string) {
    this._route.navigate(['/' + Val]);
    localStorage.clear();
  }
}



// WEBPACK FOOTER //
// ./src/app/Shared/ManagementHeader.ts